$(function(){
	var insightsPageSize = $("#insight-filter-page-size").val(),
	    analystData,
	    SegmentFilterVal = "",
	    insightServiceAreaVal = "",
	    insightsDataTotalCount = $("#insight-data-total-count").val(),
		clearInsightsFiltersBtn = $("#clearInsightsFilters"),
		insightSegmentLabel = "",
		insightServiceAreaLabel = "";

		clearInsightsFiltersBtn.hide();
	
	var updateFilter = function(selector, facet, paramName) {

		const urlParams = new URLSearchParams(window.location.search);
		const selected = urlParams.get(paramName) || "";

		const $ul = $(selector);

		let html = ""
		if (facet && facet.values) {
			html = `
				<li data-list-value="" class="${selected === "" ? "active" : ""}">
					${facet.label}
				</li>
			`;

			facet.values.forEach(v => {
				if (!v.count || v.count === 0) return;
				
				const isActive = selected === v.id;
				
				html += `
					<li data-list-value="${v.id}" class="${isActive ? "active" : ""}">
						${v.name}
						${isActive ? '<a class="clear-filter" href="javascript:void(0);">×</a>' : ""}
					</li>
				`;
			});
		}

		$ul.html(html);
		$ul.closest(".custom-select").removeClass("open").find(".custom-select-list-box").hide();
	}

	function applySelectedValue(selector, selectedValue) {
        const $custom = $(selector).closest(".custom-select");
        const $li = $custom.find(".custom-select-list li[data-list-value='" + selectedValue + "']");

        if ($li.length) {
            $li.addClass("active").siblings().removeClass("active");
            $custom.find(".custom-select-value").val($li.text().trim());
        }
    }

	function renderInsightsList(data, pageNo, pageSize) {
		analystData = "";
		data.insightItems.forEach(item => {
			analystData += `
				<div class="card-list">
					<div class="card-list-thumbnail">
						<img 
							src="${item.image && item.image[0] ? item.image[0] : '/-/media/tech/omdia/herobannerwithtile/herobannerwithtileplaceholder.jpeg'}" 
							alt="${item.image && item.image[1] ? item.image[1] : 'placeholder-img'}">
					</div>
					<div class="card-list-content">
						<h3 class="card-list-title"><a href="${item.url}">${item.title}</a></h3>
						<p>${item.body}</p>
						<a href="${item.url}" class="cta cta-large cta-secondary">Learn more</a>
					</div>
				</div>`;
		});
		initPagintation(pageNo);
		$("#insightsDataFromFrontend").html(analystData);
	}
	
	var fetchInsightsData = function(pageNo, pageSize){
		$("#insightsPaginationBackend").hide();
		$("#insightsDataFromBackend").hide();
		
		// -------- PRODUCTION MODE --------
		// $.get("/api-json/insights-data.json", {
        $.post("/api/insightsfilter/getinsightitems", {
            "PageNo": pageNo,
            "PageSize": pageSize,
			"SegmentFilter": SegmentFilterVal,
			"ServiceAreaFilter": insightServiceAreaVal
        }, function (result) {
			// ---- NEW : Get facets ----
			var segmentFacet = null;
			var serviceFacet = null;

			if (result && result.respone && result.respone.facets) {
				segmentFacet = result.respone.facets.find(f => f.id === "segments");
				serviceFacet = result.respone.facets.find(f => f.id === "topics");
				insightSegmentLabel = segmentFacet ? segmentFacet.label : "";
				insightServiceAreaLabel = serviceFacet ? serviceFacet.label : "";
			}

			// if (result && result.facets) {
			// 	segmentFacet = result.facets.find(f => f.id === "segments");
			// 	serviceFacet = result.facets.find(f => f.id === "topics");

			// 	insightSegmentLabel = segmentFacet ? segmentFacet.label : "";
			// 	insightServiceAreaLabel = serviceFacet ? serviceFacet.label : "";
			// }

			// ---- NEW : Update dropdown options ----
			updateFilter("#insightSegment .custom-select-list", segmentFacet, "SegmentFilter");
			updateFilter("#insightServiceArea .custom-select-list", serviceFacet, "ServiceAreaFilter");

			applySelectedValue("#insightSegment .custom-select-list", SegmentFilterVal);
            applySelectedValue("#insightServiceArea .custom-select-list", insightServiceAreaVal);

			// ----- RENDER INSIGHTS LIST -----
			renderInsightsList(result.respone, pageNo, pageSize);
        });
    }
    
	var totalPageCount,
		paginationHtml,
	    paginationItem,
	    pageIncrement,
	    initPage = 1,
	    firstPage = 1,
	    lastPage = 5,
	    activePage = 1;

	var initPagintation = function(currentItem) {
		totalPageCount = Math.ceil(insightsDataTotalCount / insightsPageSize);
		if (currentItem && currentItem > 2 && currentItem <= totalPageCount - 2) {
			firstPage = Number(currentItem) - 2;
			lastPage = Number(currentItem) + 2;
		}
		if (currentItem && currentItem <= 2) {
			firstPage = 1;
			lastPage = 5;
		}
		if(totalPageCount > 5){
			if (currentItem && currentItem >= totalPageCount - 2) {
				firstPage = totalPageCount - 4;
				lastPage = totalPageCount;
			}
		}
		paginationHtml = "";
		if(firstPage != 1){
			paginationHtml += `
				<li>
					<a href="#?page=${initPage}" data-index="${initPage}" title="Page ${initPage}">First</a>
				</li>
				<li>...</li>`;
		}
		for(var i = firstPage; i <= totalPageCount; i++){
			paginationItem = `<li>
								<a href="#?page=${i}" data-index="${i}" title="Page ${i}">${i}</a>
							</li>`;
			if(currentItem && currentItem == i){
				paginationItem = `<li class="active">
									<a href="#?page=${i}" data-index="${i}" title="Page ${i}">${i}</a>
								</li>`;
			}
			if(i <= lastPage){
				paginationHtml += paginationItem;
			}
		}
		if(totalPageCount > lastPage){
			paginationHtml += `
				<li>...</li>
				<li>
					<a href="#?page=${totalPageCount}" data-index="${totalPageCount}" title="Page ${totalPageCount}">Last</a>
				</li>`;
		}
		if (totalPageCount < 2) {
			paginationHtml = "";
		}
		$("#insightsPagination").html(paginationHtml);
	}
	
	var updateHashParam = function(key, value){
		const params = new URLSearchParams(window.location.search);

		// SET or DELETE
		if (value) {
			params.set(key, value);
		} else {
			params.delete(key);
		}

		// SPECIAL CASE: page
		if (key === "page" && (!value || value < 2)) {
			params.delete("page");
		}

		const query = params.toString();
		const newUrl =
			window.location.protocol +
			"//" +
			window.location.host +
			window.location.pathname +
			(query ? "?" + query : "");

		window.history.pushState({ path: newUrl }, "", newUrl);
	}

	function syncFilterState({value, filterSelector, valueSetter, defaultLabel }) {
		if (typeof value === "undefined") return;

		// Update JS variable
		valueSetter(value);

		// Update UI
		const $filter = $(filterSelector);
		const $items = $filter.find(".custom-select-list li");
		
		if (value) {
			const $matched = $items.filter(function () {
				return $(this).attr("data-list-value") === value;
			});

			if ($matched.length) {
				$matched.addClass("active").siblings().removeClass("active");
				$filter.find("input").val($matched.text().trim());
			}
		} else {
			$items.removeClass("active").first().addClass("active");
			$filter.find(".custom-select-value").val(defaultLabel);
		}

		// Show / hide Clear button
		if (SegmentFilterVal || insightServiceAreaVal) {
			clearInsightsFiltersBtn.show();
		} else {
			clearInsightsFiltersBtn.hide();
		}
	}
		
	$(document).on('click', "#insightsPagination li", function(e){
		e.preventDefault();
		//e.stopPropagation();
		var pageIndex = $(this).find("a").attr("data-index");
		updateHashParam("page", pageIndex);
		initPagintation(pageIndex);
		fetchInsightsData(pageIndex, insightsPageSize);
		activePage = pageIndex;
	});
		
	$("#insightSegment").on('click', '.custom-select-list li', function () {
		syncFilterState({
			value: $(this).attr("data-list-value"),
			filterSelector: "#insightSegment",
			valueSetter: (val) => (SegmentFilterVal = val),
			defaultLabel: insightSegmentLabel
		});

		fetchInsightsData(1, insightsPageSize);
		updateHashParam("SegmentFilter", SegmentFilterVal);
		updateHashParam('page', "");
		initPagintation(firstPage);
	});

	$("#insightServiceArea").on('click', '.custom-select-list li', function () {
		syncFilterState({
			value: $(this).attr("data-list-value"),
			filterSelector: "#insightServiceArea",
			valueSetter: (val) => (insightServiceAreaVal = val),
			defaultLabel: insightServiceAreaLabel
		});

		fetchInsightsData(1, insightsPageSize);
		updateHashParam("ServiceAreaFilter", insightServiceAreaVal);
		updateHashParam('page', "");
		initPagintation(firstPage);
	});

	clearInsightsFiltersBtn.on("click", function () {
		syncFilterState({
			value: "",
			filterSelector: "#insightSegment",
			valueSetter: (val) => (SegmentFilterVal = val),
			defaultLabel: insightSegmentLabel
		});

		syncFilterState({
			value: "",
			filterSelector: "#insightServiceArea",
			valueSetter: (val) => (insightServiceAreaVal = val),
			defaultLabel: insightServiceAreaLabel
		});

		// clear URL params
		updateHashParam("SegmentFilter", "");
		updateHashParam("ServiceAreaFilter", "");
		updateHashParam("page", "");

		// reload data
		fetchInsightsData(firstPage, insightsPageSize);
		initPagintation(firstPage);
	});

	$(document).on("click", ".insight-list-filter-item .custom-select .clear-filter", function (e) {
		e.preventDefault();
		e.stopPropagation();

		var $clearBtn = $(this);
		var $filter = $clearBtn.closest(".custom-select");
		var isSegment = $filter.is("#insightSegment");
		var isServiceArea = $filter.is("#insightServiceArea");

		// ---------- Reset values ----------
		if (isSegment) {
			SegmentFilterVal = "";
			updateHashParam("SegmentFilter", "");
		}

		if (isServiceArea) {
			insightServiceAreaVal = "";
			updateHashParam("ServiceAreaFilter", "");
		}

		// ---------- Reset dropdown UI ----------
		$filter
			.find(".custom-select-list li")
			.removeClass("active")
			.first()
			.addClass("active");

		$filter.find(".custom-select-value").val(
			isSegment ? insightSegmentLabel : insightServiceAreaLabel
		);

		// ---------- Remove self clear button ----------
		$clearBtn.remove(); // or .hide() if you want reuse later

		// ---------- Reset page ----------
		updateHashParam("page", "");

		// ---------- Reload data ----------
		fetchInsightsData(firstPage, insightsPageSize);

		// ---------- Toggle global clear button ----------
		clearInsightsFiltersBtn.toggle(
			!!(SegmentFilterVal || insightServiceAreaVal)
		);
	});

	
	var urlParams = new URLSearchParams(window.location.search);

	// ---------- Helpers ----------
	function applyDropdownFilter(wrapperSelector, inputSelector, paramValue) {
	if (!paramValue) return;

	$(wrapperSelector + " .custom-select-list li").each(function () {
		var $li = $(this);
		if ($li.attr("data-list-value") === paramValue) {
		$li.addClass("active").siblings().removeClass("active");
		$(inputSelector).val($li.text());
		}
	});
	}

	function getFeedUrl() {
	var baseUrl = $("#insightFeedUrl").val();
	var params = [
		"PageNo=" + activePage,
		"PageSize=" + insightsPageSize
	];

	if (SegmentFilterVal) params.push("SegmentFilter=" + SegmentFilterVal);
	if (insightServiceAreaVal) params.push("ServiceAreaFilter=" + insightServiceAreaVal);

	return baseUrl + "?" + params.join("&");
	}

	// ---------- Read URL Params ----------
	var SegmentFilterVal = urlParams.get("SegmentFilter") || "";
	var insightServiceAreaVal = urlParams.get("ServiceAreaFilter") || "";
	var pageFromUrl = urlParams.get("page") || firstPage;

	// ---------- Apply Filters from URL ----------
	if (insightsPageSize) {
		applyDropdownFilter("#insightSegment", "#insightSegment input", SegmentFilterVal);
		applyDropdownFilter("#insightServiceArea", "#insightServiceArea input", insightServiceAreaVal);

		if (SegmentFilterVal || insightServiceAreaVal) {
			clearInsightsFiltersBtn.show();
		}

		fetchInsightsData(pageFromUrl, insightsPageSize);
		initPagintation(pageFromUrl);
	}

		// ---------- Feed Button ----------
	$("#insightFeedData").on("click", function () {
		window.open(getFeedUrl(), "_blank");
	});

	// ---------- Menu link jump to insight section ----------
	function handleMenuNavigation(queryString) {
		if (!queryString) return;

		var params = new URLSearchParams(queryString);
		var serviceArea = params.get("ServiceAreaFilter");
		if (!serviceArea) return;

		$("#insights-archive .custom-select-list li").each(function () {
			var $li = $(this);
			$li.removeClass("active");

			if ($li.attr("data-list-value") === serviceArea) {
			$li.addClass("active");
			$("#insights-archive .custom-select-value").val($li.text());
			}
		});

		window.scrollTo({
			top: $("#insights-archive").offset().top - 150,
			behavior: "smooth"
		});
	}

	// Page load navigation
	if (insightsPageSize) {
		handleMenuNavigation(window.location.search.split("?")[1]);
	}

	// Main nav click navigation
	$(document).on("click", ".main-nav li a", function () {
		handleMenuNavigation($(this).attr("href").split("?")[1]);
	});
});